import { session } from "../auth/session"
import { ApiError } from "./errors"
import { request, type RequestOptions } from "./http"

export type ApiOptions = Omit<RequestOptions, "token">

/**
 * Authenticated API call. Attaches the in-memory access token; on 401 it
 * refreshes once (single-flight, via the httpOnly refresh cookie) and retries.
 */
export async function api<T>(path: string, options: ApiOptions = {}): Promise<T> {
  try {
    return await request<T>(path, { ...options, token: session.getAccessToken() })
  } catch (error) {
    if (!(error instanceof ApiError) || error.status !== 401) throw error
    const token = await session.refresh()
    if (!token) throw error
    return request<T>(path, { ...options, token })
  }
}
